/**
 * Frissíti a `id` azonosítóval rendelkező style elem tartalmát.
 * @param id      - A style elem azonosítója.
 * @param content - Az új tartalom.
 */
export default function updateStyleContent (id: string, content: string): void {
  let style = document.querySelector(`style#${ id }`)

  if (!style) {
    style = document.createElement('style')
    style.id = id
  }

  style.innerHTML = content

  document.head.appendChild(style)
}
